/**
 * 前端 API 配置统一入口
 *
 * 运行时根据当前端口动态决定后端地址：
 * - 8080/809x: 开发环境，使用代理 '/api'
 * - 3000: 后端开发服务器
 * - 其他: 直连后端 1580 端口
 *
 * 注意：不要在业务代码中重复此逻辑
 */

// 获取当前端口
const currentPort = typeof window !== 'undefined' ? window.location.port : '8080'

// 是否本地开发机（部署环境——IP/域名访问——一律同源 '/api'，由 nginx 反代；
// 曾按端口猜 http://host:1580 直连，在 https/IP 部署下是混合内容+端口不映射双重死）
const isLocalHost = typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname)

// 根据端口计算 baseURL
function getBaseURL() {
  if (!isLocalHost) {
    // 部署环境：同源相对路径，devServer 代理/nginx 反代均适用
    return '/api'
  }
  if (currentPort === '8080' || currentPort.startsWith('809')) {
    // 开发环境使用代理
    return '/api'
  } else if (currentPort === '3000') {
    // 后端开发服务器
    return `http://${window.location.hostname}:3000/api`
  } else {
    // 其他端口直连后端
    return `http://${window.location.hostname}:1580/api`
  }
}

// 后端服务器基础地址（用于静态资源访问）
function getServerBase() {
  if (!isLocalHost) {
    // 部署环境：同源（nginx /images/ 反代）
    return ''
  }
  if (currentPort === '8080' || currentPort.startsWith('809')) {
    // 开发环境使用代理
    return ''
  } else {
    // 直连后端
    return `http://${window.location.hostname}:1580`
  }
}

const baseURL = getBaseURL()
const serverBase = getServerBase()

// API 接口路径列表
const apiList = {
  // 用户相关
  register: '/auth/register',
  checkAuthorizationCode: '/auth/check-authorization-code',
  login: '/auth/login',
  // Phase B：refresh session 静默续期 / 服务端撤销退出（main.js 拦截器 / Center / AdminLayout 调用）
  refresh: '/auth/refresh',
  logout: '/auth/logout',
  getUserInfo: '/user/info',
  // 收货地址（多地址 CRUD 基础路径，按 id 操作时拼接 /:id 等）
  addressList: '/user/addresses',

  // 商品相关
  getProducts: '/products',
  getProductDetail: '/products',

  // 订单相关
  createOrder: '/orders',
  getMyOrders: '/orders/my',
  getOrderDetail: '/orders',

  // 搜索相关
  logSearch: '/search/log',
  getHotSearch: '/search/hot',
  getSearchHistory: '/search/history',

  // 购物车相关
  getCart: '/cart',
  addToCart: '/cart',
  updateCart: '/cart',
  deleteCart: '/cart',
  clearCart: '/cart/clear',

  // 优惠券相关（用户资产，与订单金额解耦）
  myCoupons: '/coupons/mine',
  availableCoupons: '/coupons/available',
  adminCoupons: '/admin/coupons',

  // 管理员相关
  getAdminOrders: '/admin/orders',
  updateOrderStatus: '/admin/orders',
  getAdminProducts: '/admin/products',
  getAdminProductList: '/admin/products',
  createProduct: '/admin/products',
  updateProduct: '/admin/products',
  deleteProduct: '/admin/products',
  getStats: '/admin/stats',
  uploadImage: '/upload',
  adjustUserLevel: '/admin/user/adjust-level',
  getUserLevelLogs: '/admin/user/level-logs',
  adminAuthCodes: '/admin/authorization-codes',
  adminPreUsers: '/admin/pre-users',
  adminRegistrationRequests: '/admin/registration-requests',
  sendSmsCode: '/auth/send-sms-code',
  verifySmsCode: '/auth/verify-sms-code',
  // 忘记密码（自助重置；check=HV 拼图门禁后的受保护存在性检查 → 一次性 reset_flow_token）
  pwresetCheck: '/auth/password-reset/check',
  pwresetSendCode: '/auth/password-reset/send-code',
  pwresetVerifyCode: '/auth/password-reset/verify-code',
  pwresetReset: '/auth/password-reset/reset',
  // 人机验证（HumanVerification）：场景门禁（register 已关 / password_reset 开，服务端 config 单一裁决；引擎服务端裁决，客户端不可指定）
  hvChallengeConfig: '/captcha/config',
  hvChallenge: '/captcha/challenge',
  hvVerify: '/captcha/verify',

  // 旧接口兼容
  getList: '/products',
  getIntro: '/products',
  getRandom: '/products',
  getRecommend: '/products',
  getCha: '/config/health',
  toRes: '/auth/register',
  getToken: '/auth/login',
  toLogin: '/auth/login',
  getUserbase: '/user/info',
  veriPhone: '/config/health'
}

export default {
  apiList,
  baseURL,
  serverBase,
  // 兼容旧命名
  baseTarget: serverBase,
  apiBaseUrl: baseURL
}
